'use client';

import { Button } from '@/components/ui/Button';
import { Card } from '@/components/ui/Card';
import { Icon } from '@/components/ui/Icon';
import { Alert } from '@/components/ui/Feedback';
import type { LeadSubmission } from '@/hooks/useLeadSubmission';

export function SubmissionSuccess({
  title,
  description,
  onReset,
  resetLabel = 'Send another request',
}: {
  title: string;
  description: string;
  onReset: () => void;
  resetLabel?: string;
}) {
  return (
    <Card className="flex flex-col items-center gap-4 text-center" highlighted>
      <span className="border-success/40 bg-success/10 text-success inline-flex h-14 w-14 items-center justify-center rounded-2xl border">
        <Icon name="check" className="h-7 w-7" />
      </span>
      <h2 className="text-2xl text-white">{title}</h2>
      <p className="text-content-muted max-w-md text-sm leading-relaxed">{description}</p>
      <Button variant="secondary" size="sm" onClick={onReset}>
        {resetLabel}
      </Button>
    </Card>
  );
}

/** Error banner plus the prefilled-email escape hatch from {@link LeadSubmission}. */
export function SubmissionError({ submission }: { submission: LeadSubmission }) {
  if (submission.status !== 'error' || !submission.errorMessage) return null;

  return (
    <Alert tone="error" title="We could not send that">
      <p>{submission.errorMessage}</p>
      {submission.fallbackMailto ? (
        <a href={submission.fallbackMailto} className="text-brand-bright mt-2 inline-flex items-center gap-2 font-medium underline">
          <Icon name="mail" className="h-4 w-4" />
          Send it as an email instead
        </a>
      ) : null}
    </Alert>
  );
}
